var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"91d9062d4c189660acd937899f354104d08dbc21"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["timeneye-frontend@timeneye"]={id:"91d9062d4c189660acd937899f354104d08dbc21"};
      